import React from 'react';
import { LessonSection } from '../data/courseData';
interface SectionHeaderProps {
  section: LessonSection;
}
export function SectionHeader({
  section
}: SectionHeaderProps) {
  return <h2 className="text-2xl md:text-3xl font-bold text-[#132C53] mb-6 flex items-center space-x-3" data-id="element-6753">
      <span data-id="element-6754">{section.emoji}</span>
      <span data-id="element-6755">{section.number}</span>
      <span data-id="element-6756">{section.title}</span>
    </h2>;
}